export enum WeekLockState {
    Unlocked = 1,
    Locked = 2,
    WWLocked = 3
}
